export default __webpack_public_path__ + "static/media/brainOverviewNotebookEN.06703e95.pdf";